import { Directive, HostBinding } from '@angular/core';

@Directive()
export class FooterItem {
  @HostBinding('class.first')
  public first: boolean = false;

  @HostBinding('class.last')
  public last: boolean = false;
}
